import { Controller } from '@hotwired/stimulus'

// The week popover portals outside the grid's drag scope, so it hands its
// pointerdowns to the grid's drag controller.
export default class extends Controller {
  static outlets = [ 'calendar--drag' ]

  grab(event) {
    if (this.hasCalendarDragOutlet) {
      this.calendarDragOutlet.grab(event)
    }
  }
}
